<template>
  <div class="MobileGeneral">
    <div class="mobile-header">
      <b-button class="BtnRegister" @click="modalHeight">
        <b-icon-plus
          scale="1.5"
          style="
            width: 30px;
            background: #006458;
            height: 30px;
            color: white;
            border-radius: 2px;
          "
        ></b-icon-plus>
        <span style="width: 170px">Nova Receita</span>
      </b-button>
    </div>

    <div class="status-scroll-container">
      <div class="status-card draft" @click="handleTypeSale('Rascunho')">
        <span class="status-label"> Rascunhos</span>
        <span class="status-count">{{ normalizedCounts.rascunho }}</span>
      </div>
      <div
        class="status-card finalized"
        @click="handleTypeSale('Finalizado(a)')"
      >
        <span class="status-label">Finalizadas</span>

        <span class="status-count">{{ normalizedCounts.finalizado }}</span>
      </div>
      <div class="status-card canceled" @click="handleTypeSale('Cancelado')">
        <span class="status-label">Canceladas</span>
        <span class="status-count">{{ normalizedCounts.cancelado }}</span>
      </div>
    </div>

    <div class="mobile-filters-container">
      <div class="filter-row">
        <label>Período:</label>
        <div class="date-group">
          <div class="date-field">
            <input
              type="text"
              class="date-display"
              :value="formatDateBR(startDate)"
              readonly
              tabindex="-1"
            />
            <input
              ref="startDateInput"
              type="date"
              class="date-native"
              v-model="startDate"
              @input="handlePeriodFilterChange"
            />
          </div>
          <span class="date-separator">até</span>
          <div class="date-field">
            <input
              type="text"
              class="date-display"
              :value="formatDateBR(endDate)"
              readonly
              tabindex="-1"
            />
            <input
              ref="endDateInput"
              type="date"
              class="date-native"
              v-model="endDate"
              @input="handlePeriodFilterChange"
            />
          </div>
        </div>
      </div>

      <div class="filter-row">
        <b-form-select
          v-model="type"
          :options="filterCombobox"
          size="sm"
          class="mobile-select"
          @change="handleClearInput"
        ></b-form-select>
      </div>

      <div class="filter-row search-row">
        <div v-if="type === 'status'" style="width: 100%">
          <b-form-select
            class="mobile-select"
            value-field="value"
            text-field="text"
            v-model="status"
            :options="filterSituationCombobox"
            @change="filterSale(page)"
          ></b-form-select>
        </div>
        <template v-else>
          <b-input
            v-model="textPesquisa"
            placeholder="Buscar..."
            class="mobile-search-input"
            @keyup.enter="filterSale(page)"
          ></b-input>
          <b-button @click="filterSale(page)" class="btn-search-mobile">
            <b-icon-search></b-icon-search>
          </b-button>
        </template>
      </div>
    </div>

    <div v-if="spinGeneral" class="mobile-loading-container">
      <div class="loadingLazy">
        <div class="loader">
          <span>WINFIT</span>
          <span>WINFIT</span>
        </div>
        <span style="margin-top: 10px; color: #64748b; font-size: 14px"
          >Buscando Informações...</span
        >
      </div>
    </div>

    <div v-else class="card-list-container">
      <div
        v-for="dataSearchSale in dataSale"
        :key="dataSearchSale.id"
        class="sale-card"
        :class="{ isMenuOpen: openMenuCardId === dataSearchSale.id }"
        @click="editSales(dataSearchSale.id)"
      >
        <div class="card-header-mobile">
          <span class="receipt-id">#{{ dataSearchSale.receita }}</span>
          <span class="receipt-date">{{ dataSearchSale.data | moment }}</span>
          <span
            class="status-badge"
            :class="normalizeStatus(dataSearchSale.status).toLowerCase()"
          >
            {{ normalizeStatus(dataSearchSale.status) }}
          </span>
        </div>

        <div class="card-body-mobile">
          <div class="info-group">
            <label>Cliente :</label>
            <strong>{{ dataSearchSale.nomeCliente }}</strong>
          </div>
          <div class="info-group">
            <label>Resp. Técnico :</label>
            <span>{{ dataSearchSale.nomeTecnico }}</span>
          </div>
        </div>

        <div class="card-actions-mobile">
          <b-button
            variant="link"
            class="action-btn"
            @click.stop="printReportSelect(dataSearchSale.id, false)"
          >
            <b-icon-printer-fill></b-icon-printer-fill> Imprimir
          </b-button>

          <b-button
            v-if="canUseDigitalSignature"
            variant="link"
            class="action-btn"
            @click.stop="handleOpenModalConfirmSign(dataSearchSale.id)"
          >
            <b-icon-pen></b-icon-pen> Assinar
          </b-button>

          <b-dropdown
            variant="link"
            no-caret
            class="action-dropdown"
            right
            @show="handleMenuOpen(dataSearchSale.id)"
            @hide="handleMenuClose"
          >
            <template #button-content>
              <b-icon-three-dots-vertical></b-icon-three-dots-vertical>
            </template>
            <b-dropdown-item @click.stop="editSales(dataSearchSale.id)"
              >Editar</b-dropdown-item
            >
            <b-dropdown-item
              v-if="canUseDigitalSignature"
              @click.stop="handleOpenModalConfirmSign(dataSearchSale.id)"
              >Assinar Digitalmente</b-dropdown-item
            >
            <b-dropdown-item
              variant="danger"
              @click.stop="openModalCancelPrescription(dataSearchSale.id)"
              >Cancelar</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div v-if="!spinGeneral && !dataSale.length" class="empty-state">
        <b-icon-inbox scale="2"></b-icon-inbox>
        <p>Nenhuma receita encontrada.</p>
      </div>
    </div>

    <div class="mobile-pagination">
      <b-button
        class="mobile-pagination-btn"
        :disabled="page == 1"
        @click="previousPage(page)"
      >
        Anterior
      </b-button>

      <span class="mobile-pagination-current">Página {{ page }}</span>

      <b-button
        class="mobile-pagination-btn"
        :disabled="this.dataLength < 9"
        @click="nextPage(page)"
      >
        Próxima
      </b-button>
    </div>

    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalPurchase" @click="modalHeight">
          Fechar
        </b-button>
        <MobilePrescription
          :typeComponent="'Receita'"
          @closeModal="modalHeight"
        />
      </div>
    </div>

    <ModalConfirm
      modalName="modal-confirm-cancel-prescription"
      title="Cancelar Receita ?"
      subtitle="Esta ação irá cancelar a receita. O número da ART poderá ser reutilizado em uma nova emissão. Deseja realmente cancelar?"
      rightButtonText="Sim"
      leftButtonText="Não cancelar"
      :rightButtonClick="cancelPrescription"
    />

    <ModalConfirm
      typeModal="info"
      modalName="modal-confirm-sign"
      title="Assinar Receita Digitalmente"
      subtitle="Deseja assinar digitalmente esta receita?"
      headerIcon="b-icon-patch-exclamation-fill"
      rightButtonText="Cancelar"
      leftButtonText="Assinar Digitalmente"
      :leftButtonClick="handleSignPrescription"
      @modalClosed="selectedPrescriptionId = null"
    />
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapMutations, mapState } from "vuex";
import ServicePurchase from "../../services/servicePurchase";
import serviceProductsPurchase from "../../services/serviceProductsPurchase";
import MobilePrescription from "./MobilePrescription.vue";
import printReport from "../../reports/sale";
import api from "../../services/axios";
import moment from "moment";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import serviceSale from "../../services/serviceSale";
import { hasDigitalSignaturePermission } from "../../utils/digitalSignaturePermission";

export default {
  components: {
    MobilePrescription,
    ModalConfirm,
  },
  data() {
    return {
      year: DateTime.local().year,
      month: DateTime.local(),
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      monthSelected: "",
      yearSelected: "",
      colapseModal: false,
      spinDelete: false,
      isAdvancedSearch: false,
      modalContainer: "contentModalDisable",
      idPurchaseFromModal: null,
      page: 1,
      dataLength: 0,
      sumPurchase: 0,
      countProducts: 0,
      dataPurchases: {},
      dataDetails: {},
      returnProducts: [],
      dataSale: [],
      dataSupplier: {},
      product: {},
      dataSumPurchase: {},
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "art", text: "ART/TRT" },
        { value: "clienteCidade", text: "Cidade" },
        { value: "clienteUf", text: "Estado" },
        { value: "nomeResponsavel", text: "Responsável" },
        { value: "status", text: "Status" },
        { value: "", text: "Selecione..." },
      ],
      filterSituationCombobox: [
        { value: "Rascunho", text: "Rascunho" },
        { value: "Finalizado(a)", text: "Finalizado(a)" },
        { value: "Cancelado(a)", text: "Cancelado(a)" },
        { value: "", text: "Selecione uma situação..." },
      ],
      filterMonth: [
        { value: "1", text: "Janeiro" },
        { value: "2", text: "Fevereiro" },
        { value: "3", text: "Março" },
        { value: "4", text: "Abril" },
        { value: "5", text: "Maio" },
        { value: "6", text: "Junho" },
        { value: "7", text: "Julho" },
        { value: "8", text: "Agosto" },
        { value: "9", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" },
      ],
      filterYear: [
        { value: "2021", text: "2021" },
        { value: "2022", text: "2022" },
        { value: "2023", text: "2023" },
        { value: "2024", text: "2024" },
        { value: "2025", text: "2025" },
        { value: "2026", text: "2026" },
        { value: "2027", text: "2027" },
        { value: "2028", text: "2028" },
        { value: "2029", text: "2029" },
        { value: "2030", text: "2030" },
        { value: "2031", text: "2031" },
        { value: "2032", text: "2032" },
      ],
      openMenuCardId: null,
      selectedPrescriptionId: null,
      prescriptionId: null,
      status: "",
      totalcancelado: 0,
      countCancelado: 0,
      countFinalizado: 0,
      countRascunho: 0,
      countFaturado: 0,
      totalfinalizado: 0,
      totalrascunho: 0,
      totalFaturado: 0,
      spinGeneral: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "SET_DATA_SEARCH_FROM_SALE",
      "ALTER_TYPE_DOCUMENT",
      "SET_HTML_TO_PRINT",
    ]),

    normalizeStatus(status) {
      if (!status) return "Rascunho";

      const statusLower = status.toLowerCase();
      if (statusLower.includes("rascunho")) return "Rascunho";
      if (statusLower.includes("finalizado")) return "Finalizado(a)";
      if (statusLower.includes("cancelado")) return "Cancelado";

      return status;
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";
      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_SALE({});
      }
      this.filterSale(1);
    },

    handleClearInput() {
      if (this.type !== "status") {
        this.textPesquisa = "";
      }
    },

    formatDateBR(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      if (!year || !month || !day) return "";
      return `${day}/${month}/${year}`;
    },

    async enableAdvancedSearch() {
      this.isAdvancedSearch = !this.isAdvancedSearch;
      if (!this.isAdvancedSearch) {
        this.startDate = "";
        this.endDate = "";
      }
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
    },
    handlePeriodFilterChange() {
      if (!this.startDate || !this.endDate) {
        return;
      }

      this.page = 1;
      this.filterSale(1);
    },
    async filterSale(page) {
      try {
        this.spinGeneral = true;

        if (this.type !== "status") {
          this.status = "";
        }

        const { data } = await api.get(
          `/sales?q=${this.textPesquisa}&type=${this.type}&status=${this.status}&page=${page}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=Receita`
        );

        if (!Object.keys(data).length) {
          return;
        }

        this.dataLength = data.data.length;
        this.dataSale = data.data;

        if (data.totals && Object.keys(data.totals).length) {
          this.countCancelado = data.totals.countCancelado;
          this.countFinalizado = data.totals.countFinalizado;
          this.countRascunho = data.totals.countRascunho;
          this.countFaturado = data.totals.countFaturado;

          this.totalcancelado = data.totals.cancelado;
          this.totalfinalizado = data.totals.finalizado;
          this.totalrascunho = data.totals.rascunho;
          this.totalFaturado = data.totals.faturado;
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async filterPurchase(page) {
      try {
        const data = await ServicePurchase.searchPurchase(
          this.textPesquisa,
          this.type,
          page,
          this.startDate,
          this.endDate
        );
        this.dataLength = data.data.length;
        this.dataPurchase = data.data;
        this.clearSearch();
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao listar as compras",
          type: "info",
        });
      }
    },

    monthHasChanged() {
      this.month = this.month.set({ month: parseInt(this.monthSelected) });
      this.year = this.yearSelected;
      this.filterSale(1);
    },

    getTotal(dataPurchase) {
      return dataPurchase.reduce(
        (total, purchase) => total + purchase.valorTotal,
        0
      );
    },

    async editSales(tableRowData) {
      const data = await this.searchTableDataForSale(tableRowData);
      if (data && Object.keys(data).length) {
        this.handleEditSale(data);
      }
    },

    async searchTableDataForSale(idVenda) {
      try {
        const { data } = await api.get(
          `/sales/${idVenda}?typeProduct=agrotoxicos`
        );
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },
    handleEditSale(data) {
      this.SET_DATA_SEARCH_FROM_SALE(data);

      const nameDocument = "venda";
      this.ALTER_TYPE_DOCUMENT(nameDocument);
      this.modalHeight();
    },
    async deleteAll() {
      this.spinDelete = true;
      try {
        for (const item of this.returnProducts) {
          await serviceProductsPurchase.delete(item.idProduto, item.id);
        }
        await serviceProductsPurchase.deleteAll(this.dataDetails.id);
        this.$bvModal.hide("modal-excluir");
        this.filterSale(1);

        return this.$toast.open({
          message: "Deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response}`,
            type: "error",
          });
      } finally {
        this.spinDelete = false;
      }
    },

    async printReportSelect(idSale, toSign, openedWindow = null) {
      if (!idSale) return;

      const sale = this.dataSale.find(({ id }) => id === idSale);
      if (toSign && !sale?.signedDate && !this.canUseDigitalSignature) {
        return this.$toast.info(
          "Este usuário não tem permissão para assinatura digital"
        );
      }

      const result = await printReport("receiptStandard", idSale, toSign);

      if ("html" in result) {
        if (openedWindow && !openedWindow.closed) {
          openedWindow.document.open();
          openedWindow.document.write(result.html);
          openedWindow.document.close();
        } else {
          this.SET_HTML_TO_PRINT(result.html);
        }
      } else if ("url" in result) {
        if (openedWindow && !openedWindow.closed) {
          openedWindow.location.href = result.url;
        } else {
          window.open(result.url, "_blank");
        }
      }
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    handleOpenModalConfirmSign(prescriptionId) {
      if (!this.canUseDigitalSignature) return;

      this.selectedPrescriptionId = prescriptionId;
      this.$bvModal.show("modal-confirm-sign");
    },

    async handleSignPrescription() {
      if (!this.canUseDigitalSignature) return;

      const openedWindow = window.open("", "_blank");
      try {
        await this.printReportSelect(
          this.selectedPrescriptionId,
          true,
          openedWindow
        );
      } catch (err) {
        if (openedWindow && !openedWindow.closed) {
          openedWindow.close();
        }
        this.$toast.open({
          message: "Erro ao assinar receita",
          type: "error",
        });
      }
    },

    async openModalCancelPrescription(id) {
      this.prescriptionId = id;
      this.openModals("modal-confirm-cancel-prescription");
    },

    async cancelPrescription() {
      try {
        await serviceSale.cancel(this.prescriptionId);
        this.$toast.open({
          message: "Receita cancelada com sucesso!",
          type: "success",
        });
        this.$bvModal.hide("modal-confirm-cancel-prescription");
        await this.filterSale(1);
      } catch (error) {
        this.$toast.open({
          message: error?.response?.data?.message || "Erro ao cancelar receita",
          type: "error",
        });
      }
    },

    handleTypeSale(name) {
      this.type = "status";
      this.status = name;
      this.textPesquisa = "";

      this.filterSale(1);
    },

    async editPurchase(id) {
      try {
        const data = await ServicePurchase.findPurchaseById(id);
        this.$emit("editPurchase", data);
        this.$root.$emit("bv::toggle::collapse", "accordion-dadosCadastrais");
        this.$emit("alterTabIndex", this.tabIndex);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: "Ocorreu um erro ao ler informações",
            type: "info",
          });
      }
    },

    async updateMonth(direction) {
      if (direction === "prev") {
        this.month = this.month.minus({ months: 1 });
        this.year = this.yearSelected;
        this.monthSelected = this.month.month;
      } else if (direction === "next") {
        this.month = this.month.plus({ months: 1 });
        this.year = this.yearSelected;
        this.monthSelected = this.month.month;
      }

      await this.filterSale(1);
    },

    nextPage() {
      this.filterSale((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSale((this.page -= 1));
      }
    },

    handleMenuOpen(cardId) {
      this.openMenuCardId = cardId;
    },

    handleMenuClose() {
      this.openMenuCardId = null;
    },
  },

  async mounted() {
    this.monthSelected = this.month.month;
    this.yearSelected = this.year;
    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();
    await this.filterSale(1);
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
    }),
    normalizedCounts() {
      return {
        rascunho: this.countRascunho,
        finalizado: this.countFinalizado,
        cancelado: this.countCancelado,
      };
    },
    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },
    canUseDigitalSignature() {
      return hasDigitalSignaturePermission("novaReceita");
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  async created() {
    this.ALTER_SIZE_MODAL("disable");
    if (
      this.$route.query.origem === "inspecao" &&
      (this.$store.state.dataSearchFromSale.idInspecao ||
        this.$store.state.dataSearchFromSale.inspectionId)
    ) {
      await this.$nextTick();
      await this.modalHeight();
    }
  },
};
</script>

<style scoped>
.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 0px;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  width: 100%;
  background: #ffff;
  transition: all 0.7s ease-in-out;
}
.closeModalPurchase {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 42%;
  z-index: 900;
  font-size: 10px;
  height: 30px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 0 0 20px 20px;
  color: rgb(6, 6, 6);
}

.closeModalPurchase:hover {
  background: whitesmoke;
  color: red;
}

.closeModalPurchase:focus {
  background: red;
  border: none;
  box-shadow: none;
}
.disable {
  position: absolute;
  width: 100%;
  height: 0;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}
.MobileGeneral {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 50%, #f8fafc 100%);
  padding-bottom: 80px;
  font-family: "Poppins", sans-serif;
  position: relative;
  overflow-x: hidden;
  box-sizing: border-box;
}

.MobileGeneral *,
.MobileGeneral *::before,
.MobileGeneral *::after {
  box-sizing: border-box;
}

.MobileGeneral::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(0, 98, 86, 0.05) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(64, 184, 131, 0.05) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 40% 80%,
      rgba(0, 98, 86, 0.03) 0%,
      transparent 50%
    );
  pointer-events: none;
  z-index: -1;
}

.mobile-header {
  padding: 20px 15px 45px 15px;
  width: 100%;
  max-width: 100%;
  position: relative;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  color: white;
  transition: all 0.5s ease;
  background: linear-gradient(135deg, #006256 0%, #40b883 50%, #006256 100%);
  background-size: 200% 200%;
  animation: gradientShift 8s ease infinite;
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.mobile-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  animation: shimmer 3s infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.BtnRegister {
  width: 180px;
  height: 40px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #006458;
  border: none;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.BtnRegister .b-icon {
  width: 24px !important;
  height: 24px !important;
  background: #006458 !important;
  color: white !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 12px !important;
}

.BtnRegister span {
  width: auto !important;
  font-family: "Poppins", sans-serif;
  letter-spacing: 0.3px;
}

.BtnRegister::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.5s;
}

.BtnRegister:hover::before {
  left: 100%;
}

.BtnRegister:hover {
  background: rgba(255, 255, 255, 1);
  color: #006458;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.BtnRegister:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.header-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
}

.btn-toggle-filters {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  color: #006458;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 12px;
  width: 36px;
  height: 36px;
  padding: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.btn-toggle-filters::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.5s;
}

.btn-toggle-filters:hover::before {
  left: 100%;
}

.btn-toggle-filters:hover {
  background: linear-gradient(135deg, #006256, #40b883);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 98, 86, 0.25);
}

.btn-toggle-filters:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(0, 98, 86, 0.2);
}

.mobile-filters-container {
  width: calc(100% - 30px);
  max-width: calc(100% - 30px);
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  padding: 10px 12px 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  margin: 8px 15px 0;
  overflow: hidden;
}

.filter-row {
  margin-bottom: 8px;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.filter-row label {
  font-size: 11px;
  color: #374151;
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

.date-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
  max-width: 100%;
}

.date-field {
  flex: 1;
  min-width: 0;
}

.date-display {
  display: none;
}

.date-native {
  position: static;
  width: 100%;
  opacity: 1;
  z-index: auto;
  pointer-events: auto;
}

.date-group input {
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 34px;
  font-size: 12px;
  padding: 6px 8px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
}

.date-group input:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.date-separator {
  font-size: 10px;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

.mobile-select {
  width: 100%;
  height: 34px;
  min-height: 34px;
  border-radius: 7px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  font-size: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.mobile-select:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.search-row {
  display: flex;
  align-items: stretch;
  gap: 6px;
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
}

.search-row > * {
  min-width: 0;
}

.mobile-search-input {
  flex: 1;
  min-width: 0;
  width: 100%;
  border-radius: 7px;
  height: 34px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  font-size: 12px;
}

.mobile-search-input:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.btn-search-mobile {
  background: linear-gradient(135deg, #006458, #40b883);
  border: none;
  border-radius: 7px;
  width: 34px;
  min-width: 34px;
  flex: 0 0 34px;
  height: 34px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 100, 88, 0.25);
  transition: all 0.3s ease;
}

.btn-search-mobile:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(0, 100, 88, 0.4);
}

.status-scroll-container {
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  padding: 0 15px;
  width: 100%;
  max-width: 100%;
  position: relative;
  margin-top: -30px;
  gap: 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.status-scroll-container::-webkit-scrollbar {
  display: none;
}

.status-card {
  min-width: 85px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  padding: 12px 8px;
  border-radius: 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.status-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #40b883, #006256);
  border-radius: 12px 12px 0 0;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.1);
}

.status-card.draft::before {
  background: linear-gradient(90deg, #94a3b8, #64748b);
}

.status-card.finalized::before {
  background: linear-gradient(90deg, #22c55e, #16a34a);
}

.status-card.canceled::before {
  background: linear-gradient(90deg, #ef4444, #dc2626);
}

.status-card.draft .status-label {
  color: #64748b;
  font-weight: 600;
}

.status-card.finalized .status-label {
  color: #16a34a;
  font-weight: 600;
}

.status-card.canceled .status-label {
  color: #dc2626;
  font-weight: 600;
}

.status-label {
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 4px;
  text-align: center;
}

.status-count {
  font-size: 18px;
  font-weight: 800;
  color: #1a202c;
  font-family: "Poppins", sans-serif;
  background: linear-gradient(135deg, #006256, #40b883);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.sale-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #40b883, #006256);
  border-radius: 0 12px 12px 0;
}

.sale-card:hover {
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.1);
  border-color: rgba(0, 98, 86, 0.2);
}

.sale-card:active {
  border-color: #006458;
  box-shadow: 0 4px 12px rgba(0, 98, 86, 0.15);
}

.sale-card.isMenuOpen {
  z-index: 1000;
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 98, 86, 0.1);
}

.receipt-id {
  font-weight: 800;
  color: #006458;
  font-size: 16px;
  background: linear-gradient(135deg, #006256, #40b883);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.receipt-date {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  background: rgba(0, 98, 86, 0.1);
  padding: 3px 8px;
  border-radius: 12px;
  font-family: "Poppins", sans-serif;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  display: inline-block;
  white-space: nowrap;
}

.status-badge.rascunho {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffc107;
}

.status-badge.finalizado {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #28a745;
}

.status-badge.cancelado {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 184, 131, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(64, 184, 131, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 184, 131, 0);
  }
}

.info-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
}

.info-group label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  margin: 0 !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.info-group strong {
  font-size: 14px;
  color: #1a202c;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.info-group span {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.card-actions-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  border-top: 1px solid rgba(0, 98, 86, 0.1);
  margin-top: 12px;
  padding-top: 12px;
  gap: 8px;
  position: relative;
}

.action-btn {
  font-size: 11px;
  color: #006458;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 15px;
  background: rgba(0, 98, 86, 0.1);
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-btn:hover {
  color: white;
  background: linear-gradient(135deg, #006256, #40b883);
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 98, 86, 0.3);
}

.action-dropdown {
  position: relative;
}

.action-dropdown .btn {
  padding: 6px !important;
  color: #64748b;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.action-dropdown .btn:hover {
  background: rgba(0, 98, 86, 0.1);
  color: #006458;
}

.action-dropdown .dropdown-menu {
  position: absolute !important;
  top: 100% !important;
  right: 0 !important;
  left: auto !important;
  margin-top: 4px !important;
  min-width: 160px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1001 !important;
  padding: 4px;
  transform: none !important;
}

.sale-card.isMenuOpen .dropdown-menu {
  z-index: 1002 !important;
}

.action-dropdown .dropdown-item {
  padding: 8px 12px;
  font-size: 13px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-dropdown .dropdown-item:hover {
  background: rgba(0, 98, 86, 0.1);
  color: #006458;
}

.sale-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  border-radius: 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  padding: 15px;
  width: 100%;
  max-width: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow: visible;
  backdrop-filter: blur(10px);
}

.card-list-container {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  overflow: visible;
}

@media (max-width: 764px) {
  .MobileGeneral,
  .mobile-filters-container,
  .filter-row,
  .date-group,
  .date-field {
    min-width: 0;
    max-width: 100%;
    overflow-x: hidden;
  }

  .mobile-filters-container {
    width: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }

  .date-group {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 18px minmax(0, 1fr);
    gap: 2px;
    align-items: center;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .date-field {
    position: relative;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .date-display {
    display: block;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: 34px;
    box-sizing: border-box;
    padding: 4px 8px;
    font-size: 12px;
    line-height: 1;
    border: 1px solid rgba(0, 98, 86, 0.2);
    border-radius: 7px;
    background: #fff;
    color: #111;
    pointer-events: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }

  .date-native {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 2;
    pointer-events: auto;
    cursor: pointer;
  }

  .date-separator {
    width: 18px;
    min-width: 18px;
    max-width: 18px;
    font-size: 9px;
    text-align: center;
    color: #64748b;
    overflow: hidden;
    white-space: nowrap;
  }
}

@media (max-width: 420px) {
  .mobile-pagination {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.mobile-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 15px 8px;
}

.mobile-pagination-btn {
  min-width: 92px;
  border-radius: 10px;
  border: 1px solid #d9e1e7;
  background: #fff;
  color: #006256;
  font-weight: 600;
  font-size: 13px;
}

.mobile-pagination-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mobile-pagination-current {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.fab-add {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #006458;
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 100, 88, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  transition: transform 0.2s;
}

.fab-add:active {
  transform: scale(0.95);
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8fffe 0%, #ffffff 100%);
  border-radius: 16px;
  margin: 15px;
  border: 2px dashed rgba(0, 98, 86, 0.2);
}

.empty-state .b-icon {
  color: rgba(0, 98, 86, 0.3);
  margin-bottom: 12px;
}

.empty-state p {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  font-family: "Poppins", sans-serif;
}

.mobile-loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
  padding: 20px;
}

.loadingLazy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loader {
  position: relative;
  height: 50px;
  margin-bottom: 20px;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
  font-weight: bold;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.3px #006458;
}

.loader span:nth-child(2) {
  color: #006458;
  -webkit-text-stroke: 1px #006458;
  animation: loading 3s ease-in-out infinite;
}

@keyframes loading {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      15% 44%,
      32% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      16% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
</style>
